import "./ClubPage.css";
import React from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Hero from "../Hero/Hero";
import CourseContent from "../CourseContent/CourseContent";
import ClubDescription from "../ClubDescription/ClubDescription";
import { useClubData } from "../../hooks/useClubData";
import { useUnitState } from "../../hooks/useUnitState";

const ClubPage = () => {
  const { handle } = useParams();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;
  const { ClubsList } = location.state || {};

  const {
    clubData,
    selectedGuide,
    setSelectedGuide,
    selectedHole,
    setSelectedHole,
  } = useClubData(handle, databaseUrl);

  const { unit, toggleUnit } = useUnitState(searchParams, setSearchParams);

  return (
    <>
      <Header SearchFilterData={ClubsList} />
      <Hero clubData={clubData} />
      <main className="ComponentsWrapper">
        {selectedGuide && (
          <CourseContent
            selectedGuide={selectedGuide}
            setSelectedGuide={setSelectedGuide}
            selectedHole={selectedHole}
            setSelectedHole={setSelectedHole}
            clubData={clubData}
            unit={unit}
            onUnitToggle={toggleUnit}
          />
        )}
        <ClubDescription
          description={clubData.description}
          localRules={clubData.localRules}
        />
      </main>
    </>
  );
};

export default ClubPage;
